import * as constants from '../constants';

const INITIAL_STATE = {
    item: null,
    error: null,
    loading: false,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;

        case constants.DASHBOARD_REQUESTED:
            return Object.assign({}, state, {loading: true, error: null, item: null});
        case constants.DASHBOARD_SUCCESS:
            return Object.assign({}, state, {loading: false, error: null, item: action.payload.item});
        case constants.DASHBOARD_FAILURE:
            return Object.assign({}, state, {loading: false, error: action.payload.error});
    }
    return state;
}
